import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import ChatWithRallyButton from './ChatWithRallyButton';
import {
    AllPlayersNavItem,
    AllEventsNavItem,
    AllClubsNavItem,
    GlobalSearchTennisNavItems,
    GlobalSearchPickleballNavItems,
} from './GlobalSearchNavItemDictionary';
import GlobalSearchNavItem from './GlobalSearchNavItem';

import styles from './GlobalSearchNavigation.scss';
import { useStatsig } from '../../../hooks/useStatsig';

const GlobalSearchNavItems = (props) => {
    const {
        onFilterClick,
        onTeamLeagueClick,
        onUpdateSportType,
        onEventsClick,
        onChatWithAceClick,
        canAccessChatWithAce,
    } = props;

    const { checkGate, featureGates } = useStatsig();
    const isAdultTeamPickleballDisabled = !checkGate(featureGates.ADULT_TEAM_PICKLEBALL);
    const isJuniorTeamPickleballDisabled = !checkGate(featureGates.JUNIOR_TEAM_PICKLEBALL);
    const isPaidHitsDisabled = false;
    const goldenTicketLabel = 'Golden Ticket';

    const handleOnClick = (navItem) => {
        const { filterType, sportType, label, entityType } = navItem;
        if (label === goldenTicketLabel) {
            const { type, data } = filterType;
            onFilterClick(type, data);
        } else if (navItem.isLeagues) {
            onTeamLeagueClick(filterType);
        } else if (navItem.filterType === 'events') {
            onEventsClick(sportType, entityType);
        } else {
            onFilterClick(filterType);
        }
        onUpdateSportType(sportType, entityType);
    };

    const disabledTennisLabels = {
        'Adult Team Tennis': false,
        'Junior Team Tennis': false,
        'Paid Hits': isPaidHitsDisabled,
        'Paid Hitters': isPaidHitsDisabled,
    };

    const disabledPickleballLabels = {
        'Adult Team Pickleball': isAdultTeamPickleballDisabled,
        'Junior Team Pickleball': isJuniorTeamPickleballDisabled,
    };

    return (
        <div className={styles.globalNavItems}>
            {canAccessChatWithAce && (
                <ChatWithRallyButton onClick={onChatWithAceClick} />
            )}
            <div className={styles.allPlayersNavItem}>
                <GlobalSearchNavItem
                    label={AllPlayersNavItem.label}
                    entityType={AllPlayersNavItem.entityType}
                    testId={AllPlayersNavItem.testId}
                    onClick={() => handleOnClick(AllPlayersNavItem)}
                />
                <GlobalSearchNavItem
                    label={AllEventsNavItem.label}
                    entityType={AllEventsNavItem.entityType}
                    testId={AllEventsNavItem.testId}
                    onClick={() => handleOnClick(AllEventsNavItem)}
                />
                <GlobalSearchNavItem
                    label={AllClubsNavItem.label}
                    entityType={AllClubsNavItem.entityType}
                    testId={AllClubsNavItem.testId}
                    onClick={() => handleOnClick(AllClubsNavItem)}
                />
            </div>
            <div className={styles.sportNavItemsContainer}>
                <div className={styles.navItems}>
                    <div className={styles.menuHeader}>
                        <Img
                            src="/img/tennis-icon.svg"
                            alt="search menu tennis icon"
                        />
                        <p>Tennis</p>
                    </div>
                    {GlobalSearchTennisNavItems.map((item) => {
                        const { label, entityType, testId } = item;
                        if (disabledTennisLabels[label]) {
                            return null; // Hide the item based on feature flags
                        }
                        return (
                            <GlobalSearchNavItem
                                key={label}
                                label={label}
                                entityType={entityType}
                                testId={testId}
                                onClick={() => handleOnClick(item)}
                            />
                        );
                    })}
                </div>
                <div className={styles.navItems}>
                    <div className={styles.menuHeader}>
                        <Img
                            src="/img/pickleball-icon.svg"
                            alt="search menu pickleball icon"
                        />
                        <p>Pickleball</p>
                    </div>
                    {GlobalSearchPickleballNavItems.map((item) => {
                        const { label, entityType, testId } = item;
                        if (disabledPickleballLabels[label]) {
                            return null; // Hide the item based on feature flags
                        }
                        return (
                            <GlobalSearchNavItem
                                key={label}
                                label={label}
                                entityType={entityType}
                                testId={testId}
                                onClick={() => handleOnClick(item)}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

GlobalSearchNavItems.propTypes = {
    onFilterClick: PropTypes.func.isRequired,
    onEventsClick: PropTypes.func.isRequired,
    onTeamLeagueClick: PropTypes.func.isRequired,
    onUpdateSportType: PropTypes.func.isRequired,
    onChatWithAceClick: PropTypes.func.isRequired,
    canAccessChatWithAce: PropTypes.bool.isRequired,
};

export default GlobalSearchNavItems;
